import { useEffect } from "react";
import { Flex, Typography, Image, App } from "antd";
import CopyIcon from "../../../assets/icons/copy.svg";
import { CheckOutlined } from "@ant-design/icons";
import VerifiedIcon from "../../../assets/icons/verified-icon.svg";
import Whatsapp from "../../../assets/icons/whatsapp.svg";
import Mail from "../../../assets/icons/mail.svg";
import { useDispatch, useSelector } from "react-redux";
import { getBusinessDetailedView, sendDepositDetails } from "../../../redux/slices/BusinessProfileSlice";
import { capitalizeEntireWord } from "../../../helpers/helpers";
import ProfileSectionLayout from "../../../components/ProfileSectionLayout/ProfileSectionLayout";
import NoData from "../../../components/NoData/NoData";
import { DESC_TXT, GLOBAL_CONSTANTS, SUCCESS_MSGS, TITLE_TXT } from "../../../constants/constants";
import ProfileDetail from "../../../components/Details/ProfileDetail";
import ShareDetail from "../../../components/Details/ShareDetail";

const { Title, Text } = Typography;

const EscrowDetails = () => {
    const { message } = App.useApp();
    const { user } = useSelector((state) => state.auth);
    const { busDetailedViewData, loading } = useSelector((state) => state.profile1);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getBusinessDetailedView());
    }, [dispatch, user?.orgId]);

    const escrowBank = busDetailedViewData?.bankDetails?.find((bank) => bank?.isEscrow === true);


    const copyable = {
        icon: [
            <Image preview={false} src={CopyIcon} alt="Copy Icon" key="copy-icon" />,
            <CheckOutlined key="check-icon" />,
        ],
    };

    const handleSendDeposit = async () => {
        const payload = {
            email: user?.email,
            name: user?.userName,
            beneficiaryName: escrowBank?.accHolderName,
            escrowBankName: escrowBank?.bankName,
            escrowBranchName: escrowBank?.branchName,
            escrowAccountNumber: escrowBank?.accNum,
            escrowIfscCode: escrowBank?.ifscCode,
        };

        const res = await dispatch(sendDepositDetails(payload));
        if (res.payload.statusCode === 200) {
            message.success(SUCCESS_MSGS.ECW_DET_SUC_MSG);
        }
    };

    const getFormattedEscrowDetails = () => {
        return `
Beneficiary Name: ${capitalizeEntireWord(escrowBank?.accHolderName)}
Bank Account Number: ${escrowBank?.accNum}
Bank Name: ${capitalizeEntireWord(escrowBank?.bankName)}
Branch Name: ${capitalizeEntireWord(escrowBank?.branchName)}
IFSC Code: ${escrowBank?.ifscCode}
    `.trim();
    };

    const handleCopyAllDetails = () => {
        const text = getFormattedEscrowDetails();
        navigator.clipboard.writeText(text).then(() => {
            message.success("Virtual Account details copied successfully!");
        });
    };

    return (
        <ProfileSectionLayout
            loading={loading}
            withDetailsContainer={false}
            header={(
                <Flex gap={10}>
                    <Title level={4}>{TITLE_TXT.ECW_DETS}</Title>
                    {escrowBank && <img src={VerifiedIcon} alt="Verified" />}
                </Flex>
            )}
        >
            {escrowBank ? (
                <div className="details-container">
                            <ProfileDetail
                                label={TITLE_TXT.ECW_BEN_ACC_NAME}
                                value={capitalizeEntireWord(escrowBank?.accHolderName)}
                                copyable={copyable}
                            />
                            <ProfileDetail
                                label={TITLE_TXT.ECW_BANK_ACC_NUM}
                                value={escrowBank?.accNum}
                                copyable={copyable}
                            />
                            <ProfileDetail
                                label={TITLE_TXT.ECW_BANK_NAME}
                                value={capitalizeEntireWord(escrowBank?.bankName)}
                                copyable={copyable}
                            />
                            <ProfileDetail
                                label={TITLE_TXT.ECW_BRANCH_NAME}
                                value={capitalizeEntireWord(escrowBank?.branchName)}
                                copyable={copyable}
                            />
                            <ProfileDetail
                                label={TITLE_TXT.ECW_IFSC_CODE}
                                value={escrowBank?.ifscCode}
                                copyable={copyable}
                            />

                            <Text strong>{GLOBAL_CONSTANTS.SHARE_TXT}</Text>
                            <div className="share-container">
                                <ShareDetail
                                    popTitle={TITLE_TXT.DEPO_DET_TO_WHATSAPP_CONFIRM_TXT}
                                    onConfirm={() => { }}
                                    icon={Whatsapp}
                                    shareDesc={GLOBAL_CONSTANTS.WHATSAPP}
                                />
                                <ShareDetail
                                    popTitle={TITLE_TXT.DEPO_DET_TO_EMAIL_CONFIRM_TXT}
                                    onConfirm={handleSendDeposit}
                                    icon={Mail}
                                    shareDesc={GLOBAL_CONSTANTS.EMAIL}
                                />
                                <ShareDetail
                                    popTitle="Copy all escrow details?"
                                    onConfirm={handleCopyAllDetails}
                                    icon={CopyIcon}
                                    shareDesc="Copy All"
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="no-data-container">
                            <NoData desc={DESC_TXT.ECW_DETS_NOT_AVAIL} />
                        </div>
                    )}
        </ProfileSectionLayout>
    );
};

export default EscrowDetails;
